/* =============================================================================
   LGH — Correction du nom de marque
   Remplace "GemHouse" seul par "Lydie'sGemHouse" dans les textes de la page.
   Ajoute le 28 aout 2026. Pour retirer : supprimer ce fichier de theme.liquid.
   ============================================================================= */
(function () {
  var BON = "Lydie'sGemHouse";

  function corrige(txt) {
    // on neutralise d'abord les occurrences deja correctes
    return txt
      .replace(/Lydie\s*['\u2019\u02BC]?\s*s?\s*GemHouse/gi, '\u0000')
      .replace(/Gem\s?House/g, BON)
      .replace(/\u0000/g, BON);
  }

  function parcourir(racine) {
    if (!racine) return;
    var it = document.createTreeWalker(racine, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('GemHouse') === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if (!p) return NodeFilter.FILTER_REJECT;
        var tag = p.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA' || tag === 'TITLE') return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var noeuds = [], n;
    while ((n = it.nextNode())) noeuds.push(n);
    for (var i = 0; i < noeuds.length; i++) {
      var avant = noeuds[i].nodeValue;
      var apres = corrige(avant);
      if (apres !== avant) noeuds[i].nodeValue = apres;
    }
  }

  function lancer() {
    parcourir(document.body);
    // certaines sections se chargent apres coup (sliders, apps)
    var essais = 0;
    var t = setInterval(function () {
      essais++;
      parcourir(document.body);
      if (essais > 8) clearInterval(t);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lancer);
  } else {
    lancer();
  }
})();
